(function () {
  const initSliders = () => {
    document.querySelectorAll('.swiper-container.product-card-js:not(.slider_started)').forEach((el) => {
      el.classList.add('slider_started');

      const wrapper = el.closest('.global-variant-slider');

      new Swiper(el, {
        slidesPerView: 1,
        speed: 250,
        spaceBetween: 0,
        navigation: {
          nextEl: wrapper ? wrapper.querySelector('.swiper-button-next-1') : null,
          prevEl: wrapper ? wrapper.querySelector('.swiper-button-prev-1') : null,
        },
        pagination: {
          el: el.querySelector('.product-card-pagination'),
          clickable: true,
        },
      });
    });
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Re-run on section reload (theme editor)
  document.addEventListener('shopify:section:load', initSliders);
})();

